<div class="flex w-full text-right flex-wrap surface-ground alpha-footer-container">
    <span class="flex-1 text-gray-300 px-3 alpha-footer-copyright text-sm">
        © <time [dateTime]="copyRightYear">{{ copyRightYear }}</time> Neutrinos
    </span>
</div>
